import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/about', label: 'About' },
  { to: '/canadian-real-estate', label: 'Canada' },
  { to: '/roi-calculator', label: 'ROI Calculator' },
  { to: '/faq', label: 'FAQ' },
  { to: '/blog', label: 'Blog' },
];

export default function DesktopNav() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <nav className="hidden lg:flex items-center gap-5 xl:gap-7" aria-label="Main navigation">
      {navLinks.map(({ to, label }) => (
        <Link
          key={to}
          to={to}
          aria-current={location.pathname === to ? 'page' : undefined}
          className={`text-sm font-medium transition-colors min-h-[44px] inline-flex items-center ${
            location.pathname === to ? 'text-[#806008]' : 'text-gray-700 hover:text-gray-950'
          }`}
        >
          {label}
        </Link>
      ))}
      {!isHome && (
        <Link to="/book" className="inline-flex items-center justify-center bg-gray-950 hover:bg-gray-800 text-white font-semibold px-5 py-3 rounded-md text-sm min-h-[44px] transition-colors">
          Book a Call
        </Link>
      )}
    </nav>
  );
}
